// components/GeneralEVTips.js
import React from "react";

const tips = [
    {
        parts: [
            { text: "Use " },
            { text: "ChargeFinder", link: "https://www.chargefinder.com/us" },
            { text: ", " },
            { text: "PlugShare", link: "https://www.plugshare.com" },
            { text: ", or " },
            { text: "ChargePoint", link: "https://www.chargepoint.com" },
            { text: " to find chargers." },
        ],
    },
    { text: "Level 2 chargers are fastest for quick top-ups; Level 1 works for overnight, long-term charging." },
    { text: "Return the car with at least the same charge level you started with." },
    { text: "One‑pedal driving regenerates energy and feels natural after a few minutes. It can help to maximize range." },
    { text: "Plan charging stops if your trip is longer than the vehicle’s range and take note of the charging type (CCS or NACS) and speed." },
];

export default function GeneralEVTips({ matchesSearch }) {

    return (
        <div className="bg-white rounded-lg shadow p-6">

            <h2 className="text-2xl font-bold mb-4">🔌 General EV Tips</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {tips.filter(matchesSearch).map((tip, i) => (
                    <li key={i}>
                        {tip.parts
                            ? tip.parts.map((part, j) =>
                                part.link ? (
                                    <a
                                        key={j}
                                        href={part.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline hover:text-blue-800"
                                    >
                                        {part.text}
                                    </a>
                                ) : (
                                    <span key={j}>{part.text}</span>
                                )
                            )
                            : tip.text}
                    </li>
                ))}
            </ul>
        </div>
    );
}